import React from "react";
import TXT from "presentational/common/multinational/TXT";
import { withStore } from "store/storeHandler";
import { useHistory } from "react-router-dom";
import { getEssentialUrl } from "lib/urlQueryParser";

function CopyLinkTextView(props) {
  const history = useHistory();

  const handleClick = () => {
    const { NoticeModalActions } = props;
    history.push(`${getEssentialUrl({ type: "membership" })()}#coupon`);
    NoticeModalActions.closeModal();
  };

  return (
    <div>
      <TXT key="1" name="msg_copyLink" />
      <div key="2" style={{ fontSize: 12 }}>
        <TXT
          key="3"
          name="msg_copyLinkShareMsg"
          btnFuncObj={{ coupon: handleClick }}
        />
      </div>
      <div key="4" style={{ fontSize: 12 }}>
        <TXT key="5" name="msg_copyLinkShareMsg2" />
      </div>
    </div>
  );
}

export default withStore({
  dispatchMap: ["noticeModal"]
})(CopyLinkTextView);
